jQuery(document).ready(() => {
  $('.link-input').keyup(function() {
    const context = $(this);

    const neededUrl = context.data('url');
    const value = context.val();

    if (value.indexOf(neededUrl) === 0) {
      return;
    }

    context.val(neededUrl);
  });

  $('#applyToAllIllustrators').change(function() {
    if (!$(this).prop('checked')) {
      return;
    }

    $('#confirm-links-replacing').modal({
      backdrop: 'static'
    });
  });

  $('#cancelLinksReplacing').click(() => {
    $('#applyToAllIllustrators').prop('checked', false);

    $('#confirm-links-replacing').modal('hide');
  });
});

